import React from 'react';
import PropTypes from 'prop-types';

const FormHeader = props => {
  const { title } = props;
  return <h2>{title}</h2>;
};

FormHeader.propTypes = {
  title: PropTypes.string
};

export default FormHeader;
